import {Link, useNavigate, useParams} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {KairosMark} from '@/components/kairos-mark'
import {Button} from '@/components/ui/button'
import casimiroBuscando from '@/assets/casimiro/casimiro-buscando.webp'

/** La ilustración no lleva texto horneado: lo que se lee va en HTML, traducible y audible. */
export function NotFoundPage() {
  const {t} = useTranslation()
  const {businessId} = useParams()
  const navigate = useNavigate()
  const home = businessId ? `/businesses/${businessId}` : '/'
  // Una pestaña nueva no tiene historia a la que volver.
  const puedeVolver = window.history.length > 1
  return (
    <div className="mx-auto max-w-2xl" data-testid="not-found">
      <div className="surface surface-raised overflow-hidden">
        <div className="relative flex h-44 items-center justify-center overflow-hidden bg-ink-deep text-ink-deep-foreground sm:h-52">
          <div aria-hidden="true" className="cover-ruled absolute inset-0" />
          <img
            src={casimiroBuscando}
            alt={t('notFound.casimiroAlt')}
            loading="lazy"
            decoding="async"
            className="relative h-full w-auto"
          />
        </div>
        <div className="p-8 text-center">
          <div className="flex items-center justify-center gap-2 text-muted-foreground">
            <KairosMark />
            <p className="font-mono text-[10px] font-medium tracking-[0.12em] uppercase">{t('notFound.eyebrow')}</p>
          </div>
          <h1 className="mt-3 font-heading text-2xl text-foreground">{t('notFound.title')}</h1>
          <p className="mx-auto mt-2 max-w-md text-sm text-muted-foreground">{t('notFound.body')}</p>
          <div className="mt-7 flex flex-col items-center justify-center gap-2 sm:flex-row">
            <Link
              to={home}
              replace
              data-testid="not-found-home"
              className="inline-flex min-h-9 w-full items-center justify-center rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground shadow-button transition-colors hover:bg-primary-hover sm:w-auto">
              {t('notFound.backHome')}
            </Link>
            {puedeVolver && (
              <Button variant="outline" size="lg" data-testid="not-found-back" onClick={() => navigate(-1)}>
                {t('notFound.back')}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
